// src/components/forms/FormSelect.jsx
import React from 'react';

export const FormSelect = ({
  label,
  options = [],
  error,
  required,
  className = '',
  ...props
}) => {
  return (
    <div className="form-control">
      {label && (
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <select
        className={`
          block w-full rounded-md shadow-sm transition-colors
          ${error 
            ? 'border-red-300 focus:ring-red-500 focus:border-red-500 dark:border-red-500/50' 
            : 'border-gray-300 dark:border-gray-600 focus:ring-blue-500 focus:border-blue-500'}
          bg-white dark:bg-slate-700
          text-gray-900 dark:text-white
          disabled:bg-gray-50 dark:disabled:bg-slate-800 disabled:text-gray-500 dark:disabled:text-gray-400
          sm:text-sm
          ${className}
        `}
        {...props}
      >
        <option value="">Select an option</option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {error && (
        <p className="mt-1 text-sm text-red-600 dark:text-red-400">{error}</p>
      )}
    </div>
  );
};